<template>
    <div class="main-box mh-a">
        <iristar-dividing> {{ $t("hardware.title") }} </iristar-dividing>
        <div
            class="iristar-pro-item"
            v-for="(item, index) in productList"
            :key="`${index}_product`"
        >
            <div class="flex">
                <el-image
                    class="border-r w500px"
                    :src="item.img"
                    fit="contain"
                ></el-image>
                <div class="p20 flex1">
                    <h4 class="fs24">{{ item.type }}</h4>
                    <h4 class="lh30 fs18 c-g-d">{{ item.name }}</h4>
                    <div>
                        <el-tag
                            class="m10"
                            size="small"
                            type="info"
                            v-for="(tag, idx) in item.point"
                            :key="`${idx}_tag`"
                            >{{ tag }}</el-tag
                        >
                    </div>
                    <p class="fs14 text-indent lh30 c-g-d">{{ item.desc }}</p>
                </div>
            </div>
            <div class="text-right pb20">
                <el-link
                    type="primary"
                    @click="
                        $router.push({ path: `/product-details/${item.type}` })
                    "
                    >{{ $t("button.viewDetial") }}>></el-link
                >
            </div>
        </div>
    </div>
</template>

<script>
import IristarDividing from "@/components/IristarDividing";
import ProductList from "@/assets/product/productList";
import ProductListEn from "@/assets/product/productList-en";
export default {
    name: "IristarProduct",
    computed: {
        productList() {
            let productList =
                this.$store.state.language === "zh"
                    ? ProductList
                    : ProductListEn;
            return productList;
        },
    },
    components: {
        IristarDividing,
    },
};
</script>

<style lang="less">
</style>